import { useStore } from 'react-redux'
import { Actions as PageActions } from 'actions/page'

export const usePageLoader = (): Record<string, any> => {
  const store = useStore()

  // Error
  const showLoader = (): void => {
    store.dispatch(PageActions.IS_READY(false))
  }
  // Success
  const hideLoader = (): void => {
    store.dispatch(PageActions.IS_READY(true))
  }

  return {
    showLoader,
    hideLoader,
  }
}
export default usePageLoader
